import { FormErrorMessage, TextInput, Typography } from '@analytical-alley/ui';
import { FieldErrors } from 'react-hook-form';
import { CampaignFormData } from '../schema';

interface NameStepProps {
    value: string;
    onChange: (value: string) => void;
    errors: FieldErrors<CampaignFormData>;
}

export const NameStep = ({ value, onChange, errors }: NameStepProps) => {
    return (
        <div>
            <Typography variant="bodyS" className="mb-3 text-gray-500">
                Give your campaign a recognisable name. <br/> It is used to identify
                this plan in the campaign list and across reports.
            </Typography>
            <TextInput
                className="[&_input]:h-9 [&_input]:py-0 [&_input]:focus:ring-1 [&_input]:focus:ring-[#1C64F2]"
                inputMode="text"
                name="name"
                value={value}
                onChange={(e) => onChange(e.target.value)}
            />
            {errors.name && (
                <FormErrorMessage errors={errors as any} name="name" />
            )}
        </div>
    );
};
